var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-drawer',{staticClass:"wait-prescription-drawer",attrs:{"size":"360px","title":_vm.title,"visible":_vm.visible,"direction":"rtl"},on:{"close":function($event){return _vm.$emit('close')}}},[_c('iframe',{staticStyle:{"width":"100%","height":"100%","border":"none"},attrs:{"src":_vm.iframeSrc}}),_vm._t("default",null,null,_vm.$attrs)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }